import Color from "./export-sass-colors";

export const StatusColor = (id: number) => {
  switch (id) {
    case 0:
      return Color.pending;
    case 1:
      return Color.pending;
    case 9:
      return Color.priced;
    case 10:
      return Color.paid;
    case 11:
      return Color.partial_paid;
    case 2:
      return Color.active;
    case 3:
      return Color.done;
    case 4:
      return Color.approved;
    case 5:
      return Color.denied;
    case 12:
      return Color.assigned;
    case 13:
      return Color.ticket_paused;
    case 15:
      return Color.new_client_request
    case 16:
      return Color.opened_client_request
    case 17:
      return Color.closed_client_request
    case 18:
      return Color.verfied_client_request
    case 19:
      return Color.paid_client_request
    default:
      return Color.black;
  }
};
